export default __webpack_public_path__ + "static/media/linkedin.fca54110.png";